import { Component, Inject, Input, Optional, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import device from 'current-device';
import { SettingsService } from 'src/app/services/account/settings.service';
import { LanguageService } from 'src/app/services/account/language.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { TutorialService } from 'src/app/services/core/tutorial.service';
import { CommonModule } from '@angular/common';
import { ModalOptionPanelComponent } from '../../modal-option-panel/modal-option-panel.component';

@Component({
  standalone: true,
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  imports: [CommonModule, ModalOptionPanelComponent],
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent {
  public ios: boolean = false;
  public readonly changelogDetailed = signal<boolean>(false);
  public terahive: boolean = document.URL.includes("terahive");
  @Input() firstInit: boolean = false;

  public changeLogData: { version: string, date: string, features: string[], improvements: string[], bugfixes: string[], title?: string }[] = [
    {
      version: "3.0", date: "09/22/26",
      features: ["Changelog_V30_Feature_1",
        "Changelog_V30_Feature_2",
        "Changelog_V30_Feature_3",
        "Changelog_V30_Feature_4",
        "Changelog_V30_Feature_5",
        "Changelog_V30_Feature_6",
        "Changelog_V30_Feature_7"],
      improvements: ["Changelog_V30_Improvement_1",
        "Changelog_V30_Improvement_2",
        "Changelog_V30_Improvement_3",
        "Changelog_V30_Improvement_4",
        "Changelog_V30_Improvement_5",
        "Changelog_V30_Improvement_6",
        "Changelog_V30_Improvement_7",
        "Changelog_V30_Improvement_8"],
      bugfixes: ["Changelog_V30_Bugfix_1",
        "Changelog_V30_Bugfix_2"]
    },
    {
      version: "2.6", date: "09/16/24",
      features: ["Changelog_V26_Feature_1",
        "Changelog_V26_Feature_2",
        "Changelog_V26_Feature_3",
        "Changelog_V26_Feature_4",
        "Changelog_V26_Feature_5",
        "Changelog_V26_Feature_6",
        "Changelog_V26_Feature_7"],
      improvements: ["Changelog_V26_Improvement_1",
        "Changelog_V26_Improvement_2",
        "Changelog_V26_Improvement_3"],
      bugfixes: ["Changelog_V26_Bugfix_1",
        "Changelog_V26_Bugfix_2"]
    },
    {
      version: "2.5", date: "02/23/24",
      features: [],
      improvements: ["Changelog_V25_Improvement_1"],
      bugfixes: ["Changelog_V25_Bugfix_1"]
    },
    {
      version: "2.4", date: "02/12/24",
      features: [],
      improvements: ["Changelog_V24_Improvement_1"],
      bugfixes: []
    },
    {
      version: "2.3", date: "12/13/23",
      features: ["Changelog_V23_Feature_1"],
      improvements: [],
      bugfixes: ["Changelog_V23_Bugfix_1"]
    },
    {
      version: "2.2", date: "10/02/23",
      features: [],
      improvements: ["Changelog_V22_Improvement_1", "Changelog_V22_Improvement_2"],
      bugfixes: []
    },
    {
      version: "2.1", date: "03/30/23",
      features: ["Changelog_V21_Feature_1", "Changelog_V21_Feature_2",
        "Changelog_V21_Feature_3"],
      improvements: ["Changelog_V21_Improvement_1", "Changelog_V21_Improvement_2", "Changelog_V21_Improvement_3",
        "Changelog_V21_Improvement_4", "Changelog_V21_Improvement_5"],
      bugfixes: ["Changelog_V21_Bugfix_1"]
    },
    {
      version: "2.03", date: "07/01/22",
      features: [],
      improvements: ["Changelog_V203_Improvement_1"],
      bugfixes: []
    },
    {
      version: "2.02", date: "10/21/21",
      features: [],
      improvements: ["Changelog_V202_Improvement_1"],
      bugfixes: []
    },
    {
      version: "2.0", date: "07/29/21",
      features: ["Changelog_V20_Feature_1", "Changelog_V20_Feature_2"],
      improvements: ["Changelog_V20_Improvement_1", "Changelog_V20_Improvement_2", "Changelog_V20_Improvement_3"],
      bugfixes: []
    },
    {
      version: "1.9", date: "05/20/21",
      features: ["Changelog_V19_Feature_1"],
      improvements: ["Changelog_V19_Improvement_1"],
      bugfixes: ["Changelog_V19_Bugfix_1"]
    },
    {
      version: "1.8", date: "03/11/21",
      features: ["Changelog_V18_Feature_1", "Changelog_V18_Feature_2", "Changelog_V18_Feature_3"],
      improvements: ["Changelog_V18_Improvement_1"],
      bugfixes: ["Changelog_V18_Bugfix_1"]
    },
    {
      version: "1.7", date: "01/13/21",
      features: [],
      improvements: ["Changelog_V17_Improvement_1", "Changelog_V17_Improvement_2"],
      bugfixes: ["Changelog_V17_Bugfix_1"]
    },
    {
      version: "1.6", date: "10/20/20",
      features: [],
      improvements: ["Changelog_V16_Improvement_1"],
      bugfixes: []
    },
    {
      version: "1.5", date: "10/08/20",
      features: ["Changelog_V15_Feature_1", "Changelog_V15_Feature_2"],
      improvements: ["Changelog_UpdatingCarDatabase"],
      bugfixes: []
    },
    {
      version: "", date: "11/25/20",
      features: [],
      improvements: [],
      bugfixes: [],
      title: "Changelog_LaunchIOSApp_Title"
    },
    {
      version: "", date: "05/07/20",
      features: [],
      improvements: [],
      bugfixes: [],
      title: "Changelog_LaunchAndroidApp_Title"
    },
    {
      version: "1.4", date: "05/25/20",
      features: ["Changelog_V14_Feature_1"],
      improvements: ["Changelog_V14_Improvement_1",
        "Changelog_V14_Improvement_2"],
      bugfixes: []
    },
    {
      version: "1.3", date: "04/25/20",
      features: ["Changelog_V13_Feature_1"],
      improvements: ["Changelog_V13_Improvement_1", "Changelog_V13_Improvement_2", "Changelog_UpdatingCarDatabase"],
      bugfixes: ["Changelog_V13_Bugfix_1"]
    },
    {
      version: "1.2", date: "03/05/20",
      features: [],
      improvements: ["Changelog_UpdatingCarDatabase"],
      bugfixes: []
    },
    {
      version: "1.1", date: "02/27/20",
      features: ["Changelog_V11_Feature_1"],
      improvements: ["Changelog_V11_Improvement_1", "Changelog_V11_Improvement_2"],
      bugfixes: []
    },
    {
      version: "1.0", date: "02/12/20",
      features: [],
      improvements: [],
      bugfixes: [],
      title: "Changelog_V10_Title"
    }
  ];

  constructor(public settingsService: SettingsService, public languageService: LanguageService, private readonly utilsService: UtilsService,
    private readonly tutorialService: TutorialService,
    @Optional() public dialogRef: MatDialogRef<WelcomeComponent> | null,
    @Optional() @Inject(MAT_DIALOG_DATA) data: { firstInit?: boolean }) {
    if (device.ios()) {
      this.ios = true;
    }
    if (data?.firstInit) {
      this.firstInit = true;
    }
  }

  public openUrl(url): void {
    this.utilsService.openUrlOnNewTab(device, url);
  }

  /**
   * Changelog entries from 3.0 on hold translation keys; everything older is still
   * the plain English text it was written as, so an unknown key falls back to itself.
   */
  public logText(log: string | undefined): string {
    if (!log) { return ''; }
    return this.languageService.languageJSON[log] ?? log;
  }

  public onStartClick(): void {
    this.dialogRef?.close();
  }

  // On first launch the car selector is queued right behind this dialog, so
  // the guided tutorial waits until the whole modal stack is gone.
  public onOpenTutorialClick(): void {
    this.dialogRef?.close();
    this.tutorialService.startAfterModalsClosed();
  }
}
